"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changePassword = changePassword;
exports.createUser = createUser;
exports.deleteUser = deleteUser;
exports.getInfo = getInfo;
exports.getQuqaoUser = getQuqaoUser;
exports.getUser = getUser;
exports.getUserList = getUserList;
exports.login = login;
exports.logout = logout;
exports.updateUser = updateUser;
var _request = _interopRequireDefault(require("@/utils/request"));
function login(data) {
  return (0, _request.default)({
    url: '/token/',
    method: 'post',
    data: data
  });
}
function logout() {
  return (0, _request.default)({
    url: '/token/black/',
    method: 'get'
  });
}
function getInfo() {
  return (0, _request.default)({
    url: '/system/user/info/',
    method: 'get'
  });
}
function getUserList(query) {
  return (0, _request.default)({
    url: '/system/user/',
    method: 'get',
    params: query
  });
}
function getUser(id) {
  return (0, _request.default)({
    url: "/system/user/".concat(id, "/"),
    method: 'get'
  });
}
function createUser(data) {
  return (0, _request.default)({
    url: '/system/user/',
    method: 'post',
    data: data
  });
}
function updateUser(id, data) {
  return (0, _request.default)({
    url: "/system/user/".concat(id, "/"),
    method: 'put',
    data: data
  });
}
function deleteUser(id, data) {
  return (0, _request.default)({
    url: "/system/user/".concat(id, "/"),
    method: 'delete',
    data: data
  });
}
function changePassword(data) {
  return (0, _request.default)({
    url: '/system/user/password/',
    method: 'put',
    data: data
  });
}
function getQuqaoUser(query) {
  return (0, _request.default)({
    url: '/system/qudaouser/',
    method: 'get',
    params: query
  });
}